import { render } from "./WhatsappIcon.vue?vue&type=template&id=396bb2f7"
import script from "./WhatsappIcon.vue?vue&type=script&lang=js"
export * from "./WhatsappIcon.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__